module.exports = __webpack_public_path__ + "static/media/unwanted-car-buyers-woodridge.6650966e.png";